<template>
    <SquareBtn :color="color"
               size="lg"
               class="cancel-btn"
               @click="$emit('click')">
        {{ customText ? customText : l(label) }}
    </SquareBtn>
</template>

<script>
import SquareBtn from '@/vue/components/SquareBtn';

export default {
    components: { SquareBtn },

    props: {
        color: {
            type: String,
            default: 'default',
        },
        customText: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: 'CANCEL',
        },
    },

    emits: [
        'click',
    ],
};
</script>
